import { render, staticRenderFns } from "./CustomQuillEditor.vue?vue&type=template&id=d923e572&scoped=true&"
import script from "./CustomQuillEditor.vue?vue&type=script&lang=js&"
export * from "./CustomQuillEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomQuillEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomQuillEditor.vue?vue&type=style&index=1&id=d923e572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d923e572",
  null
  
)

export default component.exports